import React, { useState, useEffect } from 'react';
import { PropertyForm } from './PropertyForm';
import { AxiosAPI } from '../../../../../../../../helpers/AxiosAPI';
import { postAPI_Create_Property, putAPI_Update_Domains, postAPI_Create_Subscribed_Property_Products } from '../../../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Validation from '../../../../../../../../components/Validation';
import { fetchServiceRequest } from '../../../../../../../../redux/service/actions';
import { NotificationManager } from '../../../../../../../../components/common/react-notifications';
function CreatePropertyForm({ propertyId, groupId, groupCurrency, serviceProvider, featuresUrl, fetchServiceRequest, }) {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  useEffect(() => {
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider, fetchServiceRequest]);
  const handleSubmit = async (data, applicableProducts) => {
    try {
      const propertyRes = await AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Property}`,
        data,
      });

      // Handle property creation validation
      if (
        propertyRes.data.HttpStatusCode !== undefined && propertyRes.data.HttpStatusCode === 400 && propertyRes.data.Messages !== undefined
        && propertyRes.data.Messages !== null && propertyRes.data.Messages.length > 0
      ) {
        setMsg(propertyRes.data.Messages);
        setOpen(true);
        return;
      }
      applicableProducts.propertyId = propertyRes.data.id;
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Create_Subscribed_Property_Products}`,
        data: applicableProducts,
      })
      // console.log('123', propertyRes.data)
      // Get the new property ID from API response
      const newPropertyId = propertyRes.data?.id;

      if (!newPropertyId) {
        throw new Error('Property ID missing from response');
      }

      // domain data
      const domainData = {
        domains: [...data.domains],
        updater: 'admin',
      };

      // Update domain for the newly created property
      const domainRes = await AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Domains}/${newPropertyId}`,
        data: domainData,
      });

      if (
        domainRes.data?.HttpStatusCode === 400 &&
        domainRes.data?.Messages?.length > 0
      ) {
        setMsg(domainRes.data.Messages);
        setOpen(true);
        return;
      }

      NotificationManager.success(
        '',
        'Property and domain created successfully',
        3000
      );

      setVisible(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error('Error during creating new property:', error);
      NotificationManager.error(
        'An error occurred while creating property.',
        'Error',
        3000
      );
    }
  };

  return (
    <div>
      <Button
        color="primary"
        className="top-right-button mr-1 mt-2 ml-2"
        outline
        size="xs"
        onClick={() => {
          setVisible(!visible);
        }}
      // style={{ width: '100%', borderRadius: '6px' }}
      >
        + Create a New Property
      </Button>
      <PropertyForm
        formLabel="Create a New Property"
        visible={visible}
        toggle={() => {
          setVisible(!visible);
        }}
        submit={handleSubmit}
        groupId={groupId}
        groupCurrency={groupCurrency}
        provider={featuresUrl}
      />
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div>

  );
}

const mapStateToProps = ({ settings, service }) => {
  const { propertyId, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    propertyId,
    serviceProvider,
    featuresUrl,
  };
};

export default injectIntl(connect(mapStateToProps, { fetchServiceRequest })(CreatePropertyForm));
